const route = () => '/admin-documents';

export default route;


